import { Link } from '@inertiajs/react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

function CategoryTabs({ selectedCategory, categoryGroups }) {
  const activeCategoryGroup = categoryGroups.find((group) =>
    group.categories.some((cat) => cat.id === selectedCategory.id),
  );

  return (
    <>
      <Box display="flex" justifyContent="center" borderBottom="1px solid" borderColor="gray.200">
        {categoryGroups.map((group) => (
          <Box
            component={Link}
            key={group.id}
            href={`/browse/${group.categories[0].handle}`}
            aria-label={`Browse ${group.name} categories (show ${group.categories[0].name} first)`}
            preserveScroll
            preserveState
            sx={{
              fontWeight: 700,
              textAlign: 'center',
              textDecoration: 'none',
              color: 'gray.900',
              px: 3,
              py: 2,
              borderBottom: '3px solid',
              borderColor: activeCategoryGroup?.id === group.id ? 'secondary.main' : 'transparent',
            }}
          >
            {group.name}
          </Box>
        ))}
      </Box>

      <Box py={3} borderBottom="1px solid" borderColor="gray.200">
        <Box display="flex" justifyContent="center" flexWrap="wrap" gap={1}>
          {(activeCategoryGroup?.categories || []).map((cat) => (
            <Box
              component={Link}
              key={cat.id}
              href={`/browse/${cat.handle}`}
              aria-label={`Browse ${cat.name} ${cat.id === selectedCategory.id ? '(currently showing)' : ''}`}
              preserveScroll
              preserveState
              sx={{
                fontWeight: 700,
                textDecoration: 'none',
                textAlign: 'center',
                color: 'gray.900',
                px: 1,
                py: 1.25,
                borderRadius: '37px',
                backgroundColor: cat.id === selectedCategory.id ? 'secondary.main' : 'transparent',
              }}
            >
              {cat.name}
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
}

CategoryTabs.propTypes = {
  selectedCategory: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  categoryGroups: PropTypes.array,
};

export default CategoryTabs;
